/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_Item2Inputs */

const tr_hakkimizda_s3_item2 = /** @type {(inputs: Hakkimizda_S3_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase PostgreSQL (AB/İrlanda, KVKK ve GDPR uyumlu veri konumu)`)
};

const en_hakkimizda_s3_item2 = /** @type {(inputs: Hakkimizda_S3_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase PostgreSQL (EU/Ireland, KVKK and GDPR compliant data location)`)
};

const de_hakkimizda_s3_item2 = /** @type {(inputs: Hakkimizda_S3_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase PostgreSQL (EU/Irland, KVKK- und GDPR-konformer Datenstandort)`)
};

const ru_hakkimizda_s3_item2 = /** @type {(inputs: Hakkimizda_S3_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supabase PostgreSQL (ЕС/Ирландия, размещение данных в соответствии с KVKK и GDPR)`)
};

/**
* | output |
* | --- |
* | "Supabase PostgreSQL (EU/Ireland, KVKK and GDPR compliant data location)" |
*
* @param {Hakkimizda_S3_Item2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_item2 = /** @type {((inputs?: Hakkimizda_S3_Item2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_Item2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_item2(inputs)
	if (locale === "de") return de_hakkimizda_s3_item2(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_item2(inputs)
	return tr_hakkimizda_s3_item2(inputs)
});